import { z } from 'zod/v4';

type StepId = string;

export type FieldKey<FieldName extends string> = `${StepId}.${FieldName}`;

export const snapshotValueLabelSchema = z.strictObject({
  value: z.string(),
  label: z.string(),
  meta: z.strictObject({}),
});

export type SnapshotValueLabel = z.infer<typeof snapshotValueLabelSchema>;
